import {takeEvery} from 'redux-saga/effects'

import {
  CREATE_INQUIRY_STATUS_SETTING,
  DELETE_INQUIRY_STATUS_SETTING,
  GET_INQUIRY_EMAIL_SETTING,
  GET_INQUIRY_STATUS_SETTING,
  UPDATE_INQUIRY_EMAIL_SETTING,
  UPDATE_INQUIRY_STATUS_SETTING,
} from '../../Actions/InquirySetting/ActionTypes/ApiActionType'
import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_INQUIRY_EMAIL_SETTING, fetchData)
  yield takeEvery(UPDATE_INQUIRY_EMAIL_SETTING, fetchData)
  yield takeEvery(GET_INQUIRY_STATUS_SETTING, fetchData)
  yield takeEvery(CREATE_INQUIRY_STATUS_SETTING, fetchData)
  yield takeEvery(UPDATE_INQUIRY_STATUS_SETTING, fetchData)
  yield takeEvery(DELETE_INQUIRY_STATUS_SETTING, fetchData)
}

export default dataSaga
